export default {
  sm: `
    350여 개의 로컬 통신사들과
    함께하는 클라우드 서비스
  `,
  md: `
    350여 개의 로컬 통신사들과 
    함께하는 클라우드 서비스
  `,
  lg: `
    350여 개의 로컬 통신사들과 함께하는
    클라우드 서비스
  `,
  xxl: `
    350여 개의 로컬 통신사들과 함께하는
    클라우드 서비스
  `,
};
